import axios from "axios"
import { toast } from "react-toastify";
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL


export const CreateLoanGranting=async(formData)=>{
    console.log(formData);
    try{
        const responce = await axios.post(`${BACKEND_URL}/api/loangranting`,formData);
        if(responce==="OK"){
            toast.success("Added")
        }
        return responce
    }catch(error){
        const message = (error.response && error.response.data && error.response.data.message
        ) || error.message || error.toString()
        toast.error(message)
    }
}


export const GetLoanGranting =async()=>{
    try{
        const responce = await axios.get(`${BACKEND_URL}/api/loangranting`);
        return responce;
    }catch(error){
        const message = (error.response && error.response.data && error.response.data.message
        ) || error.message || error.toString()
        toast.error(message)
    }
}


export const GetByIdLoanGranting =async(amdno)=>{
    try{
        const responce = await axios.get(`${BACKEND_URL}/api/loangranting/${amdno}`);
        return responce.data;
    }catch(error){
        const message = (error.response && error.response.data && error.response.data.message
        ) || error.message || error.toString()
        toast.error(message)
    }
}


export const updateLoanGranting = async(formData)=>{
    try{
        const responce = await axios.patch(`${BACKEND_URL}/api/loangranting`,formData)
        return responce.data


    }catch(error){
        const message = (error.response && error.response.data && error.response.data.message
        ) || error.message || error.toString()
        toast.error(message)
    }
}


export const CheckAmdNo = async(formData)=>{
    try{
        const responce = await axios.post(`${BACKEND_URL}/api/loangranting/check/${formData}`)
        return responce.data


    }catch(error){
        const message = (error.response && error.response.data && error.response.data.message
        ) || error.message || error.toString()
        toast.error(message)
    }
}